import { useState } from "react";
import { ChevronUp, MessageSquareText } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function FAQAccordion({ item, isOpen, onToggle }) {
  const { t } = useTranslation();
  return (
    <div className="bg-white dark:bg-white/5 rounded-lg border-defaultBlack/10 border-[1px]">
      <button
        onClick={onToggle}
        className="w-full text-left px-6 py-4 flex items-center gap-4 justify-between focus:outline-none"
      >
        <span className="text-lg font-semibold">{t(item.question)}</span>
        <div className="self-start">
          <ChevronUp
            className={`h-6 w-6 text-primary transition-all duration-300 ${
              isOpen ? "rotate-0" : "rotate-180"
            }`}
          />
        </div>
      </button>
      <div
        className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-96 pb-6" : "max-h-0"
        }`}
      >
        <p className="leading-relaxed">{t(item.answer)}</p>
      </div>
    </div>
  );
}

function FaqsSection({ faqs }) {
  const [openIndex, setOpenIndex] = useState(0);
  const { t } = useTranslation();

  return (
    <div
      className="pt-20 bg-white dark:bg-defaultBlack dark:text-white"
      id="faqs"
    >
      <div className="container mx-auto px-4 md:px-0">
        <h1 className="text-3xl font-bold mb-8">{t("faqsSection.title")}</h1>
        <div className="w-full ">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Left Content - FAQ List */}
            <div>
              <div className="space-y-3">
                {faqs.map((faq, index) => (
                  <FAQAccordion
                    key={index}
                    item={faq}
                    isOpen={index === openIndex}
                    onToggle={() =>
                      setOpenIndex(index === openIndex ? -1 : index)
                    }
                  />
                ))}
              </div>
            </div>

            {/* Right Content - Contact Information */}

            <div className="flex items-center bg-white dark:bg-white/5 rounded-lg border-defaultBlack/10 border-[1px] shadow-sm">
              <div className="p-8 w-full text-center leading-loose">
                <div className="flex items-center justify-center bg-opacity-10 rounded-full mb-6">
                  <MessageSquareText className="w-16 h-16 stroke-[rgb(0,73,69)]" />
                </div>
                <h2 className="text-2xl font-bold mb-4">
                  {t("faqsSection.more.title")}
                </h2>
                <p className="">
                  {t("faqsSection.more.line1.part1")}{" "}
                  <Link
                    to="/help-center"
                    className="text-blue-500 font-bold hover:underline"
                  >
                    {t("faqsSection.more.line1.part2")}
                  </Link>{" "}
                  {t("faqsSection.more.line1.part3")}{" "}
                </p>
                <p>
                  <a
                    href="tel:+250794776745"
                    className="text-blue-500 font-bold hover:underline"
                  >
                    +250 794776745
                  </a>
                  , {t("faqsSection.more.line2")}{" "}
                </p>
                <p>
                  <a
                    href="mailto:info@uplus.rw"
                    className="text-blue-500 font-bold hover:underline"
                  >
                    info@uplus.rw
                  </a>{" "}
                  {t("faqsSection.more.line3")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqsSection;
